// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-payments__list[data-v-57c3673b]{display:flex;grid-gap:var(--spaces-m);align-items:center;justify-content:center;width:100%}.footer-payments__item[data-v-57c3673b]{display:flex;background-color:var(--footer-payment-bg-color);border-radius:var(--radius-xxs)}.footer-payments__icon[data-v-57c3673b]{height:32px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
